import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Seo from '../components/Seo';
import { GUIDES } from '../content/guides';

const styles = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  :root {
    --green: #1B4332; --green2: #2D6A4F; --greenlt: #D8F3DC;
    --warn: #B45309; --warnlt: #FEF3C7;
    --danger: #991B1B; --dangerlt: #FEE2E2;
    --bg: #F5F2EC; --card: #FDFCF9; --dark: #1A1A18;
    --mid: #4A4A45; --light: #8A8A82; --border: #E2DDD4;
    --serif: 'Fraunces', Georgia, serif;
    --sans: 'DM Sans', sans-serif;
  }
  .lp { font-family: var(--sans); background: var(--bg); color: var(--dark); line-height: 1.6; }
  .lp a { color: inherit; text-decoration: none; }
  .lp nav { background: var(--dark); padding: 16px 48px; display: flex; justify-content: space-between; align-items: center; position: sticky; top: 0; z-index: 100; }
  .lp .logo { font-family: var(--serif); font-size: 22px; font-weight: 300; color: #fff; }
  .lp .logo em { color: #6ee7b7; }
  .lp .nav-links { display: flex; gap: 24px; align-items: center; }
  .lp .nav-links a { color: rgba(255,255,255,.6); font-size: 14px; transition: color .15s; }
  .lp .nav-links a:hover { color: #fff; }
  .lp .btn { display: inline-block; padding: 10px 22px; border-radius: 8px; font-weight: 600; font-size: 14px; transition: all .15s; cursor: pointer; font-family: var(--sans); border: none; white-space: nowrap; flex-shrink: 0; }
  .lp .btn-primary { background: var(--green); color: #fff; }
  .lp .btn-primary:hover { background: var(--green2); }
  .lp .btn-outline { background: transparent; color: #fff; border: 1.5px solid rgba(255,255,255,.3); }
  .lp .btn-outline:hover { border-color: #fff; }
  .lp .btn-lg { padding: 15px 34px; font-size: 16px; border-radius: 10px; }
  .lp .btn-white { background: #fff; color: var(--green); }
  .lp .btn-dark { background: var(--dark); color: #fff; }
  .lp .btn-mint { background: #6ee7b7; color: #0f2e22; }
  .lp .btn-mint:hover { background: #86efc5; }
  .lp .btn:focus-visible { outline: 2px solid #6ee7b7; outline-offset: 2px; }
  .lp .hero { background: var(--dark); padding: 80px 48px; text-align: center; position: relative; overflow: hidden; }
  .lp .hero::before { content:''; position:absolute; inset:0; background:radial-gradient(ellipse at 50% 0%, rgba(27,67,50,.8) 0%, transparent 70%); pointer-events:none; }
  .lp .hero-inner { position: relative; max-width: 760px; margin: 0 auto; z-index: 1; }
  .lp .deadline-badge { display:inline-block; background:var(--dangerlt); color:var(--danger); padding:6px 16px; border-radius:20px; font-size:13px; font-weight:600; margin-bottom:24px; }
  .lp .hero h1 { font-family:var(--serif); font-size:clamp(36px,6vw,64px); font-weight:300; color:#fff; line-height:1.15; margin-bottom:20px; }
  .lp .hero h1 em { color:#6ee7b7; font-style:italic; }
  .lp .hero p { font-size:18px; color:rgba(255,255,255,.6); max-width:560px; margin:0 auto 36px; }
  .lp .hero-cta { display:flex; gap:12px; justify-content:center; flex-wrap:wrap; }
  .lp .hero-sub { margin-top:16px; font-size:13px; color:rgba(255,255,255,.4); }
  .lp section { padding: 80px 48px; }
  .lp .section-tight { padding: 48px; }
  .lp .section-flush { padding: 0 48px 48px; }
  .lp .container { max-width: 1100px; margin: 0 auto; }
  .lp .section-label { font-size:12px; font-weight:600; color:var(--green); text-transform:uppercase; letter-spacing:.1em; margin-bottom:12px; }
  .lp h2 { font-family:var(--serif); font-size:clamp(28px,4vw,44px); font-weight:300; line-height:1.2; margin-bottom:16px; }
  .lp h2 em { color:var(--green); font-style:italic; }
  .lp .section-sub { font-size:17px; color:var(--mid); max-width:580px; margin-bottom:48px; }
  .lp .stats { display:grid; grid-template-columns:repeat(auto-fit,minmax(180px,1fr)); gap:24px; text-align:center; }
  .lp .stat-num { font-family:var(--serif); font-size:48px; font-weight:300; color:var(--green); line-height:1; }
  .lp .stat-label { font-size:14px; color:var(--mid); margin-top:6px; }
  .lp .deadline-banner { background:var(--dangerlt); border:1px solid var(--danger); border-radius:12px; padding:20px 28px; display:flex; align-items:center; justify-content:space-between; gap:16px; flex-wrap:wrap; margin-bottom:48px; }
  .lp .deadline-banner p { color:var(--danger); font-weight:600; font-size:15px; }
  .lp .deadline-banner span { color:var(--danger); font-size:13px; font-weight:400; }
  .lp .rra-section { background:var(--dark); }
  .lp .rra-section h2 { color:#fff; }
  .lp .rra-section h2 em { color:#6ee7b7; }
  .lp .rra-section .section-label { color:#6ee7b7; }
  .lp .rra-section .section-sub { color:rgba(255,255,255,.6); }
  .lp .rra-items { display:grid; grid-template-columns:repeat(auto-fit,minmax(240px,1fr)); gap:16px; }
  .lp .rra-item { background:rgba(255,255,255,.06); border:1px solid rgba(255,255,255,.1); border-radius:10px; padding:20px; }
  .lp .rra-item h4 { color:#6ee7b7; font-size:14px; font-weight:600; margin-bottom:6px; }
  .lp .rra-item p { color:rgba(255,255,255,.6); font-size:13px; }
  .lp .features { display:grid; grid-template-columns:repeat(auto-fit,minmax(280px,1fr)); gap:24px; }
  .lp .feature-card { background:var(--card); border:1.5px solid var(--border); border-radius:12px; padding:28px; }
  .lp .feature-icon { font-size:32px; margin-bottom:12px; }
  .lp .feature-card h3 { font-size:17px; font-weight:600; margin-bottom:8px; }
  .lp .feature-card p { font-size:14px; color:var(--mid); line-height:1.6; }
  .lp .feature-tag { display:inline-block; background:var(--warnlt); color:var(--warn); font-size:11px; font-weight:600; padding:2px 8px; border-radius:4px; margin-bottom:10px; }
  .lp .pricing-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(220px,1fr)); gap:20px; }
  .lp .price-card { background:var(--card); border:1.5px solid var(--border); border-radius:12px; padding:28px; position:relative; }
  .lp .price-card.popular { border-color:var(--green); border-width:2px; }
  .lp .popular-badge { position:absolute; top:-12px; left:50%; transform:translateX(-50%); background:var(--green); color:#fff; font-size:11px; font-weight:700; padding:3px 14px; border-radius:20px; white-space:nowrap; }
  .lp .price-plan { font-weight:700; font-size:15px; margin-bottom:6px; }
  .lp .price-amount { font-family:var(--serif); font-size:36px; font-weight:300; color:var(--green); }
  .lp .price-period { font-size:13px; color:var(--light); }
  .lp .price-props { font-size:13px; color:var(--mid); margin:10px 0 16px; }
  .lp .price-features { list-style:none; margin-bottom:20px; }
  .lp .price-features li { font-size:13px; color:var(--mid); padding:4px 0; }
  .lp .price-features li::before { content:'✓ '; color:var(--green); font-weight:700; }
  .lp .pain-points { display:grid; grid-template-columns:repeat(auto-fit,minmax(260px,1fr)); gap:20px; margin-bottom:48px; }
  .lp .pain-card { background:var(--card); border:1.5px solid var(--border); border-radius:12px; padding:24px; display:flex; gap:16px; align-items:flex-start; }
  .lp .pain-icon { font-size:28px; flex-shrink:0; }
  .lp .pain-card h4 { font-size:15px; font-weight:600; margin-bottom:4px; }
  .lp .pain-card p { font-size:13px; color:var(--mid); line-height:1.5; }
  .lp .testimonial-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(280px,1fr)); gap:20px; margin-bottom:48px; }
  .lp .testimonial { background:var(--card); border:1.5px solid var(--border); border-radius:12px; padding:24px; }
  .lp .testimonial p { font-size:15px; color:var(--dark); line-height:1.6; margin-bottom:16px; font-style:italic; }
  .lp .scenario p { font-style: normal; }
  .lp .testimonial-author { font-size:13px; font-weight:600; color:var(--mid); }
  .lp .health-score { background:var(--dark); border-radius:16px; padding:32px; text-align:center; max-width:400px; margin:0 auto 48px; }
  .lp .score-number { font-family:var(--serif); font-size:72px; font-weight:300; color:#6ee7b7; line-height:1; }
  .lp .score-label { color:rgba(255,255,255,.6); font-size:14px; margin-top:8px; }
  .lp .faq { max-width: 760px; }
  .lp .faq details { background: var(--card); border: 1.5px solid var(--border); border-radius: 12px; padding: 18px 22px; margin-bottom: 12px; }
  .lp .faq summary { cursor: pointer; font-weight: 600; font-size: 16px; list-style: none; display: flex; justify-content: space-between; gap: 16px; }
  .lp .faq summary::-webkit-details-marker { display: none; }
  .lp .faq summary::after { content: '+'; color: var(--green); font-size: 20px; line-height: 1; }
  .lp .faq details[open] summary::after { content: '\\2212'; }
  .lp .faq summary:focus-visible { outline: 2px solid var(--green); outline-offset: 4px; }
  .lp .faq p { margin-top: 10px; font-size: 14px; color: var(--mid); }
  .lp .cta-section { background:var(--green); text-align:center; padding:80px 48px; }
  .lp .cta-section h2 { color:#fff; margin-bottom:12px; }
  .lp .cta-section p { color:rgba(255,255,255,.7); font-size:17px; margin-bottom:32px; }
  .lp .cta-sub { margin-top:16px; font-size:13px; color:rgba(255,255,255,.5); }
  .lp footer { background:var(--dark); padding:40px 48px; display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:16px; }
  .lp footer p { color:rgba(255,255,255,.4); font-size:13px; }
  .lp .footer-links { display:flex; gap:24px; }
  .lp .footer-links a { color:rgba(255,255,255,.4); font-size:13px; }
  @media (max-width: 768px) {
    .lp .hero > div[style] { grid-template-columns: 1fr !important; }
    .lp .hero h1 { text-align: center !important; }
    .lp .hero p { text-align: center !important; }
    .lp .hero .hero-cta { justify-content: center !important; }
    .lp .hero .hero-sub { text-align: center !important; }
    .lp .hero .deadline-badge { display: block !important; text-align: center; }
    .two-col-cards { grid-template-columns: 1fr !important; }
    .lp .deadline-banner { flex-direction: column; }
    .lp nav { padding:14px 16px; }
    .lp .logo { flex-shrink: 0; font-size: 18px; }
    .lp .nav-links { gap: 10px; }
    .lp .nav-hide { display:none; }
    .lp .btn { padding: 9px 14px; font-size: 13px; }
    .lp section { padding:60px 20px; }
    .lp .section-tight { padding: 40px 20px; }
    .lp .section-flush { padding: 0 20px 40px; }
    .lp .hero { padding:60px 20px; }
    .lp .hero-cta { flex-direction: column; }
    .lp .hero-cta .btn { width: 100%; text-align: center; }
    .lp .hero-sub { line-height: 1.8; }
    .lp footer { padding:32px 20px; flex-direction:column; text-align:center; }
    .lp .deadline-banner { flex-direction:column; }
  }
  @media (max-width: 400px) {
    .lp .nav-cta { display:none; }
  }
`;

const PLAN_FEATURES = {
  starter:   ['All certificates tracked', 'Email reminders', 'Right to Rent', 'AI tenancy checker', 'Deposit tracker', 'Document proof log'],
  landlord:  ['Everything in Starter', 'HMO licensing checker', 'Compliance reports PDF', 'Notes & timeline', 'Priority support'],
  portfolio: ['Everything in Landlord', 'Contractor marketplace', 'Phone support', 'Account manager', 'Custom onboarding'],
};

const FAQS = [
  { q: "What does LandlordComply track?", a: "It tracks your EPC, Gas Safety, EICR, smoke alarm, CO alarm and Legionella certificates for every property. It also covers deposits, served documents, Right to Rent records and Renters' Rights Act items such as information sheets, pet requests and rent reviews." },
  { q: "How do the reminders work?", a: "You get email alerts 90, 30 and 7 days before each certificate or renewal expires, for every property in your account." },
  { q: "How does the free trial work?", a: "Every plan includes a 14-day free trial, and you can cancel anytime." },
  { q: "Can I check one property without a subscription?", a: "Yes. The one-off compliance report costs £19.99 for a single property. You don't need an account, and you get a PDF by email plus a 30-day access link." },
  { q: "What does the AI tenancy checker do?", a: "You paste in your tenancy agreement and the checker flags illegal clauses, missing mandatory items and unfair terms under UK housing law. It is a guide to help you spot issues, not a substitute for legal advice." },
  { q: "How many properties can I manage?", a: "Each plan covers a different number of properties, shown in the pricing section. If you manage more than 50 properties, contact us about an enterprise plan." },
];

const FAQ_LD = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQS.map(f => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Landing() {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    fetch('/api/plans')
      .then(r => r.json())
      .then(data => setPlans(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, []);

  return (
    <div className="lp">
      <style>{styles}</style>
      <Seo
        title="Landlord Compliance Software UK | Certificates, Deposits & RRA"
        description="Track gas safety, EICR, EPC, deposits and Renters' Rights Act duties in one dashboard. Automatic reminders. 14-day free trial."
        path="/"
        jsonLd={FAQ_LD}
      />

      {/* Nav */}
      <nav aria-label="Main">
        <span className="logo">Landlord<em>Comply</em></span>
        <div className="nav-links">
          <a href="#features" className="nav-hide">Features</a>
          <a href="#pricing" className="nav-hide">Pricing</a>
          <Link to="/guides" className="nav-hide">Guides</Link>
          <Link to="/login" className="btn btn-outline">Sign in</Link>
          <Link to="/signup" className="btn btn-mint nav-cta">Start free trial</Link>
        </div>
      </nav>

      <main>
      {/* Hero */}
      <div className="hero">
        <div style={{ maxWidth:1100, margin:'0 auto', display:'grid', gridTemplateColumns:'1fr 380px', gap:48, alignItems:'center', position:'relative', zIndex:1 }}>
          {/* Left — main CTA */}
          <div style={{ textAlign:'left' }}>
            <div className="deadline-badge" style={{ display:'inline-block' }}>⚠️ Renters' Rights Act now in force — are you compliant?</div>
            <h1 style={{ textAlign:'left' }}>Never miss a<br /><em>landlord legal deadline</em><br />again.</h1>
            <p style={{ textAlign:'left', margin:'0 0 36px' }}>One dashboard. Every certificate, document, deposit and deadline tracked automatically. Sleep easy knowing you're protected.</p>
            <div className="hero-cta" style={{ justifyContent:'flex-start' }}>
              <Link to="/signup" className="btn btn-mint btn-lg">Start your free trial →</Link>
              <a href="#features" className="btn btn-outline btn-lg">See how it works</a>
            </div>
            <p className="hero-sub" style={{ textAlign:'left' }}>14-day free trial · Cancel anytime</p>
          </div>

          {/* Right — one-off report card */}
          <div style={{ background:'rgba(255,255,255,.06)', border:'1px solid rgba(255,255,255,.12)', borderRadius:16, padding:28 }}>
            <p style={{ fontSize:12, fontWeight:600, color:'#6ee7b7', textTransform:'uppercase', letterSpacing:'.08em', marginBottom:12 }}>No subscription needed</p>
            <h3 style={{ fontSize:22, fontWeight:300, color:'#fff', lineHeight:1.3, marginBottom:12 }}>
              Is your property <em style={{ color:'#6ee7b7' }}>actually compliant?</em>
            </h3>
            <p style={{ fontSize:14, color:'rgba(255,255,255,.6)', lineHeight:1.6, marginBottom:20 }}>
              Most landlords think they are. Many aren't. Get a full compliance report for a single property — instantly.
            </p>
            <ul style={{ listStyle:'none', marginBottom:24 }}>
              {['Certificate status', 'Deposit compliance', 'Right to Rent records', 'Professional PDF by email', '30-day access link'].map(item => (
                <li key={item} style={{ display:'flex', alignItems:'center', gap:8, marginBottom:8, fontSize:13, color:'rgba(255,255,255,.7)' }}>
                  <span style={{ color:'#6ee7b7', fontWeight:700 }}>✓</span> {item}
                </li>
              ))}
            </ul>
            <Link to="/report/buy" className="btn btn-outline btn-lg" style={{ display:'block', textAlign:'center', width:'100%' }}>
              Check now — £19.99 →
            </Link>
            <p style={{ textAlign:'center', fontSize:12, color:'rgba(255,255,255,.3)', marginTop:10 }}>One-off · No account needed</p>
          </div>
        </div>
      </div>

      {/* Stats */}
      <section className="section-tight" style={{ background: 'var(--card)' }}>
        <div className="container">
          <div className="stats">
            <div><div className="stat-num">£40K</div><div className="stat-label">Maximum council penalty for electrical safety breaches</div></div>
            <div><div className="stat-num">2.82M</div><div className="stat-label">Private landlords in England</div></div>
            <div><div className="stat-num">2 yrs</div><div className="stat-label">Maximum rent repayment order, up from 1 year</div></div>
            <div><div className="stat-num">6</div><div className="stat-label">Legal certificates tracked per property</div></div>
          </div>
        </div>
      </section>

      {/* Pain points */}
      <section>
        <div className="container">
          <div className="section-label">Why landlords use us</div>
          <h2>The things that keep<br />landlords <em>up at night</em></h2>
          <p className="section-sub">One missed deadline can cost thousands. One missing document can undermine a possession claim. We make sure none of that happens to you.</p>
          <div className="pain-points">
            {[
              { icon: '😰', title: 'Expired certificates', body: 'Gas cert lapsed? EICR overdue? Councils can fine landlords up to £40,000 for electrical safety breaches, and gas safety failures can mean prosecution.' },
              { icon: '📋', title: 'Deposit mistakes', body: "Failed to protect a deposit or serve prescribed information on time? Tenant can claim up to 3× the deposit back." },
              { icon: '📬', title: 'Document not served', body: "Can't prove you served the EPC, Gas Safety or How to Rent? Your possession claim could be undermined before you even start." },
              { icon: '🏠', title: 'RRA confusion', body: 'The rules changed on 1 May 2026. Pet requests, rent reviews, possession grounds, information sheets — all different now.' },
              { icon: '🔑', title: 'HMO licensing gaps', body: 'Wrong licence or missing fire cert? Your HMO could be shut down and you could face prosecution.' },
              { icon: '📅', title: 'Missed renewals', body: 'Insurance, mortgage fix, gas cert — renewals pile up across multiple properties. One slip is one too many.' },
            ].map(p => (
              <div key={p.title} className="pain-card">
                <div className="pain-icon">{p.icon}</div>
                <div>
                  <h4>{p.title}</h4>
                  <p>{p.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Deadline banner + one-off report — side by side */}
      <section className="section-flush">
        <div className="container">
          <div className="two-col-cards" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:20 }}>
            <div className="deadline-banner" style={{ margin:0 }}>
              <div>
                <p>🚨 Information Sheet deadline has passed (31 May 2026)</p>
                <span>Not sure every tenant has received the official GOV.UK Information Sheet? Log it with proof of service.</span>
              </div>
              <Link to="/signup" className="btn btn-dark">Track compliance →</Link>
            </div>
            <div style={{ background:'#1a1a18', border:'1px solid rgba(255,255,255,.1)', borderRadius:12, padding:'20px 28px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:16, flexWrap:'wrap' }}>
              <div>
                <p style={{ color:'#6ee7b7', fontWeight:600, fontSize:15 }}>🔍 Is your property actually compliant?</p>
                <span style={{ color:'rgba(255,255,255,.6)', fontSize:13 }}>Get a full compliance report for £19.99 — no subscription needed.</span>
              </div>
              <Link to="/report/buy" className="btn btn-outline">Check now →</Link>
            </div>
          </div>
        </div>
      </section>


      {/* RRA section */}
      <section className="rra-section" id="rra">
        <div className="container">
          <div className="section-label">Renters' Rights Act 2025</div>
          <h2>Built for the <em>biggest change</em><br />in rental law in 30 years</h2>
          <p className="section-sub">The Renters' Rights Act received Royal Assent in October 2025. Every landlord in England is affected. LandlordComply has every tool you need built in.</p>
          <div className="rra-items">
            {[
              { title: '📋 Information Sheet Tracker', body: "Track who's received the mandatory RRA Information Sheet. Deadline was 31 May 2026. Log who has it, when and how." },
              { title: '🏠 End of Section 21',         body: 'Log possession notices with valid grounds under the new system. Section 21 abolished from 1 May 2026.' },
              { title: '💷 Rent Review Tracker',       body: 'One increase per year max. Track Section 13 notices and get reminded when reviews are due.' },
              { title: '🐾 Pet Request Log',           body: 'You can refuse a pet request only with a valid reason. Record every request, decision and refusal reason with a full audit trail.' },
            ].map(item => (
              <div key={item.title} className="rra-item">
                <h4>{item.title}</h4>
                <p>{item.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section id="features">
        <div className="container">
          <div className="section-label">Features</div>
          <h2>Everything you need<br />to run rentals <em>like a professional</em></h2>
          <p className="section-sub">Stop juggling spreadsheets and calendar reminders. LandlordComply gives you one place for everything — with automatic alerts before anything goes wrong.</p>
          <div className="features">
            {[
              { icon: '✅', tag: null,         title: 'Certificate Tracker',      body: 'EPC, Gas Safety, EICR, Smoke Alarms, CO Alarms and Legionella tracked across every property. Automatic reminders at 90, 30 and 7 days.' },
              { icon: '💰', tag: null,         title: 'Deposit Compliance',       body: 'Track protection scheme, prescribed information served, and deadlines. Deposit mistakes cost landlords thousands — we prevent them.' },
              { icon: '📬', tag: null,         title: 'Document Proof Log',       body: 'Log exactly when and how you served every legal document — EPC, Gas Safety, How to Rent, Information Sheet. Protection if disputed.' },
              { icon: null, tag: 'AI-powered', title: 'Tenancy Checker',          body: "Paste your tenancy agreement — our AI flags illegal clauses, missing mandatory items, and unfair terms under UK housing law." },
              { icon: '🏢', tag: null,         title: 'HMO Licensing',            body: "Know exactly what licences your HMO needs. Check fire safety compliance. Never get caught with the wrong licence." },
              { icon: '📊', tag: null,         title: 'Compliance Health Score',  body: 'A single score across your whole portfolio. Know instantly where you stand and what needs attention first.' },
              { icon: '📝', tag: null,         title: 'Notes & Timeline',         body: 'Log inspections, incidents, communications and key events per property. Your complete property history in one place.' },
              { icon: '🔔', tag: null,         title: 'Email Reminders',          body: 'Never miss a renewal. Automatic alerts at 90, 30 and 7 days before every expiry — for every property.' },
              { icon: '🔧', tag: 'Coming soon', title: 'Contractor Marketplace', body: 'Need a gas engineer, EPC assessor or electrician? Find vetted local contractors and book directly from your dashboard.' },
            ].map(f => (
              <div key={f.title} className="feature-card">
                {f.tag && <div className="feature-tag">{f.tag}</div>}
                {f.icon && <div className="feature-icon">{f.icon}</div>}
                <h3>{f.title}</h3>
                <p>{f.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Common scenarios */}
      <section style={{ background: 'var(--card)' }}>
        <div className="container">
          <div className="section-label">Common scenarios</div>
          <h2>How landlords<br /><em>get caught out</em></h2>
          <div className="testimonial-grid">
            {[
              { story: "A landlord tracks everything in a spreadsheet. The gas safety certificate lapses and nobody notices for three months. A reminder at 90 days would have caught it.", label: "Expired certificate" },
              { story: "A landlord is unsure what the Renters' Rights Act changes. Information sheets, pet requests and the new possession rules all need records, and they are scattered across emails.", label: "Renters' Rights Act" },
              { story: "A landlord protects the deposit but serves the prescribed information late. The 30-day deadline passes, and a tenant can claim compensation.", label: "Deposit protection" },
            ].map((t, i) => (
              <div key={i} className="testimonial scenario">
                <p>{t.story}</p>
                <div className="testimonial-author">{t.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section id="pricing">
        <div className="container">
          <div className="section-label">Pricing</div>
          <h2>Less than the cost of<br />one missed <em>legal deadline</em></h2>
          <p className="section-sub">A single fine or failed possession notice costs far more than a year's subscription. Start free, cancel anytime.</p>
          <div className="pricing-grid">
            {plans.map(plan => (
              <div key={plan.id} className={`price-card${plan.id === 'landlord' ? ' popular' : ''}`}>
                {plan.id === 'landlord' && <div className="popular-badge">MOST POPULAR</div>}
                <div className="price-plan">{plan.name}</div>
                <div>
                  <span className="price-amount">£{Math.round(plan.price_gbp / 100)}</span>
                  <span className="price-period">/month</span>
                </div>
                <div className="price-props">
                  {plan.property_limit >= 999 ? 'Unlimited' : `Up to ${plan.property_limit}`} properties
                </div>
                <ul className="price-features">
                  {(PLAN_FEATURES[plan.id] || []).map(f => <li key={f}>{f}</li>)}
                </ul>
                <Link
                  to="/signup"
                  className={`btn ${plan.id === 'landlord' ? 'btn-primary' : 'btn-outline'}`}
                  style={{ width:'100%', textAlign:'center', display:'block', color: plan.id === 'landlord' ? '#fff' : 'var(--dark)', borderColor: plan.id !== 'landlord' ? 'var(--border)' : undefined }}
                >
                  Start free trial
                </Link>
              </div>
            ))}
            {plans.length === 0 && (
              ['Starter — £9/mo', 'Landlord — £19/mo', 'Portfolio — £49/mo'].map(p => (
                <div key={p} className="price-card">
                  <div className="price-plan">{p}</div>
                  <Link to="/signup" className="btn btn-outline" style={{ width:'100%', textAlign:'center', display:'block', marginTop:16, color:'var(--dark)', borderColor:'var(--border)' }}>Start free trial</Link>
                </div>
              ))
            )}
          </div>
          <p style={{ textAlign:'center', marginTop:24, fontSize:13, color:'var(--light)' }}>All plans include a 14-day free trial. Prices exclude VAT. Cancel anytime.</p>
          <p style={{ textAlign:'center', marginTop:8, fontSize:13, color:'var(--light)' }}>
            Managing more than 50 properties?{' '}
            <a href="mailto:contact@landlordcomply.uk" style={{ color:'var(--green)' }}>Contact us</a>
            {' '}for an enterprise plan.
          </p>
        </div>
      </section>


      {/* Guides */}
      <section id="guides">
        <div className="container">
          <div className="section-label">Landlord guides</div>
          <h2>Plain-English guides for <em>landlords in England</em></h2>
          <p className="section-sub">Checked against GOV.UK and HSE guidance, dated, and linked to their sources.</p>
          <div className="features">
            {GUIDES.slice(0, 3).map(g => (
              <Link key={g.slug} to={`/guides/${g.slug}`} className="feature-card" style={{ display:'block' }}>
                <h3>{g.title}</h3>
                <p>{g.summary}</p>
              </Link>
            ))}
          </div>
          <p style={{ marginTop:24 }}><Link to="/guides" style={{ color:'var(--green)', fontWeight:600, textDecoration:'underline' }}>See all landlord guides</Link></p>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq">
        <div className="container">
          <div className="section-label">FAQ</div>
          <h2>Common <em>questions</em></h2>
          <div className="faq">
            {FAQS.map(f => (
              <details key={f.q}>
                <summary>{f.q}</summary>
                <p>{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <div className="cta-section">
        <div className="container">
          <h2>Stop worrying.<br />Start protecting your investment.</h2>
          <p>Join landlords across England who use LandlordComply to stay compliant, avoid fines, and run their rentals with confidence.</p>
          <Link to="/signup" className="btn btn-white btn-lg">Start your free trial →</Link>
          <p className="cta-sub">14-day free trial · Cancel anytime</p>
        </div>
      </div>

      </main>

      {/* Footer */}
      <footer>
        <span className="logo" style={{ fontSize:18 }}>Landlord<em style={{ color:'#6ee7b7' }}>Comply</em></span>
        <p>© 2026 LandlordComply. All rights reserved.</p>
        <div className="footer-links">
          <Link to="/login">Sign in</Link>
          <a href="#pricing">Pricing</a>
          <Link to="/guides">Guides</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/contact">Contact</Link>
        </div>
      </footer>
    </div>
  );
}
